import type { ColorScheme } from '../../types'

const tokens = (colorScheme: ColorScheme) => {
  const prefix = colorScheme === 'light' ? 'light.' : ''
  return {
    menuBg: `${prefix}bg.card-elevated`,
    menuBorder: `${prefix}border.subtle`,
    itemHoverBg: `${prefix}bg.table-row-hover`,
    selectedBg: `${prefix}bg.table-row-hover`,
    textPrimary: `${prefix}text.primary`,
    textDisabled: `${prefix}text.disabled`,
  }
}

export const getMenuStyles = (colorScheme: ColorScheme) => {
  const t = tokens(colorScheme)
  return {
    menu: {
      bg: t.menuBg,
      border: '1px solid',
      borderColor: t.menuBorder,
      boxShadow: '0px 4px 12px rgba(0,0,0,0.4)',
      minWidth: '214px',
      zIndex: 10,
    },
    item: (
      disabled: boolean,
      selected = false,
      fontSize: number | string = '12px',
      padding: number | string = '10px',
      lineHeight: number | string = '16px'
    ) => ({
      alignItems: 'center' as const,
      bg: selected ? t.selectedBg : undefined,
      color: disabled ? t.textDisabled : t.textPrimary,
      cursor: disabled ? ('not-allowed' as const) : ('pointer' as const),
      display: 'flex' as const,
      fontFamily: "'Soehne', 'Söhne', sans-serif",
      fontSize,
      fontWeight: selected ? '600' : '400',
      gap: '10px',
      lineHeight,
      opacity: disabled ? 0.5 : 1,
      px: padding,
      py: padding,
      _hover: disabled ? {} : { bg: t.itemHoverBg },
    }),
    // Scroll the item list once it exceeds maxHeight; no cap when unset.
    menuScroll: (maxHeight?: number | string) => ({
      maxHeight,
      overflowY: maxHeight ? ('auto' as const) : undefined,
    }),
  }
}
